import { createSlice } from '@reduxjs/toolkit';
import i18n from 'i18n/i18n';

type DeliveryDestMasterState = {
  loading: boolean;
  loadingExportExcel: boolean;
  filterSearchTotal: number;
  filterInitialSearchData: [];
  filterSearchData: any[];
  sortSelected: string;
  sortDirection: string;
  message: string;
  deliveryDestDetail: object;
  success: boolean;
};

const initialState: DeliveryDestMasterState = {
  loading: false,
  loadingExportExcel: false,
  filterSearchTotal: 0,
  filterInitialSearchData: [],
  filterSearchData: [],
  sortSelected: '',
  sortDirection: '',
  message: '',
  deliveryDestDetail: {},
  success: false,
};

export const deliveryDestMasterSlice = createSlice({
  name: 'deliveryDestMaster',
  initialState,
  reducers: {
    filterDeliveryDest: (state, action) => {
      state.loading = true;
      state.message = '';
    },
    filterDeliveryDestSuccess: (state, action) => {
      state.loading = false;
      state.filterInitialSearchData = action.payload?.records;
      state.filterSearchData = action.payload?.records;
      if (!action.payload?.total) {
        state.message = i18n.t('message.common.0001');
      }
      state.filterSearchTotal = action.payload?.total;
      state.success = false;
    },
    filterDeliveryDestFailure: (state) => {
      state.loading = false;
    },
    getDetailDeliveryDest: (state, action) => {
      state.loading = true;
    },
    getDetailDeliveryDestSuccess: (state, action) => {
      state.loading = false;
      state.deliveryDestDetail = action.payload;
    },
    getDetailDeliveryDestFailure: (state, action) => {
      state.loading = false;
      state.message = action.payload?.message;
    },
    setLoadingExportExcel: (state, action) => {
      state.loadingExportExcel = action.payload;
    },
    registerDeliveryDest: (state, action) => {
      state.loading = true;
      state.success = false;
    },
    registerDeliveryDestSuccess: (state, action) => {
      state.loading = false;
      state.success = true;
      state.message = i18n.t('message.delivery_dest_master.0001');
    },
    registerDeliveryDestFailure: (state, action) => {
      state.loading = false;
      state.success = false;
      state.message = i18n.t('message.delivery_dest_master.0002');
    },
    updateDeliveryDest: (state, action) => {
      state.loading = true;
      state.success = false;
      state.message = i18n.t('message.delivery_dest_master.0004');
    },
    updateDeliveryDestSuccess: (state, action) => {
      state.loading = false;
      state.success = true;
      state.message = action.payload?.message;
    },
    updateDeliveryDestFailure: (state, action) => {
      state.loading = false;
      state.success = false;
      state.message = action.payload?.message;
    },
    deleteDeliveryDest: (state, action) => {
      state.loading = true;
      state.success = false;
    },
    deleteDeliveryDestSuccess: (state, action) => {
      state.loading = false;
      state.success = true;
      state.message = action.payload?.message;
    },
    deleteDeliveryDestFailure: (state, action) => {
      state.loading = false;
      state.success = false;
      state.message = action.payload.message;
    },
    cleanDataDeliveryDest: (state) => {
      state.deliveryDestDetail = {};
    },
    cleanMessage: (state) => {
      state.message = '';
    },
    cleanData: (state) => {
      return {
        ...initialState,
      };
    },
  },
});

export const {
  filterDeliveryDest,
  filterDeliveryDestSuccess,
  filterDeliveryDestFailure,
  setLoadingExportExcel,
  getDetailDeliveryDest,
  getDetailDeliveryDestSuccess,
  getDetailDeliveryDestFailure,
  registerDeliveryDest,
  registerDeliveryDestSuccess,
  registerDeliveryDestFailure,
  updateDeliveryDest,
  updateDeliveryDestSuccess,
  updateDeliveryDestFailure,
  deleteDeliveryDest,
  deleteDeliveryDestSuccess,
  deleteDeliveryDestFailure,
  cleanDataDeliveryDest,
  cleanMessage,
  cleanData,
} = deliveryDestMasterSlice.actions;

export default deliveryDestMasterSlice.reducer;
